import { IHttpApi } from "@cian/http-api/shared";
import { IHttpApiFetchConfig } from "@cian/http-api/shared/http";
import {
  // mapGetArticleListErrorResponse,
  mapGetArticleListResponse
} from "../../../node/mappers/transformGetArticleListResponse";
import {
  fetchGetArticleList,
  IGetArticleListRequest, IGetArticleListResponse
} from "../../../node/repositories/backend-content/v1/get-content-item";
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ArticlesActionType } from './types';

// export const getArticlesFetching = actionGenerator<ArticlesActionType.fetching>(ArticlesActionType.fetching);
export const getArticlesSuccess = actionGenerator<ArticlesActionType.success, IGetArticleListResponse>(
  ArticlesActionType.success,
);
export const getArticlesFailure = actionGenerator<ArticlesActionType.failure>(ArticlesActionType.failure);

function resolveArticleList(httpApi: IHttpApi, parameters: IGetArticleListRequest, config: IHttpApiFetchConfig) {
  return fetchGetArticleList({
    httpApi,
    parameters,
    mappers: {
      200: mapGetArticleListResponse,
      // 400: mapGetArticleListErrorResponse,
    },
    config,
  });
}

interface IGetArticles {
  page: number,
  ordering: string,
  tag: string,
  category?: string,
  regionID: string,
  search: string,
  rubricId?: number,
}

export const getArticles = (params: IGetArticles): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, custom: {subdomain} } = context;

    const parameters = {
      'page': params['page'],
      'ordering': params['ordering'],
      'tag': params['tag'],
      'category': params['category'],
      'region_id': params['regionID'],
      'search': params['search'],
      'rubric_id': params['rubricId'],
    };
    const httpConfig = {subdomain};

    try {
      const { response } = await resolveArticleList(httpApi, parameters, httpConfig);
      dispatch(getArticlesSuccess(response));
    } catch (e) {
      dispatch(getArticlesFailure());
    }
  };
};
